<template>
    <!--Duy edit 06/02/2024-->
    <!-- <div class="the-datepicker">
        <div class="row mb-2">
            <label v-if="title && title.trim().length > 0" for="" class="col-12 col-form-label text-sm" style="">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
            </label>
            <div class="col-12">
                <VueDatePicker v-model="model" :enable-time-picker="false" :readonly="isReadOnly || false" :placeholder="placeholder || ''" format="dd/MM/yyyy" auto-apply :state="error ? false : true" :close-on-auto-apply="true" :min-date="minDate" :max-date="maxDate" @update:model-value="$emit('onChangeDate', $event)" />
            </div>
        </div>
        <div class="text-danger text-right mb-2" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div> -->
    <div class="form-group">
        <label v-if="title && title.trim().length > 0">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <VueDatePicker 
        v-model="model" :enable-time-picker="false" :disabled="isReadOnly? true: false" 
        :placeholder="placeholder || ''" format="dd/MM/yyyy" auto-apply :state="error ? false : true" 
        :close-on-auto-apply="true" :min-date="minDate" :max-date="maxDate" @update:model-value="$emit('onChangeDate', $event)" 
        range :text-input="isTextInput? true: false" 
        />
        <div class="text-danger text-right" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { ref, toRefs } from "vue";
export default {
    components: {
        
    },
    name: "TheDateRangePicker",
    props: {
        title: String,
        placeholder: String,
        initialValue: String,
        error: String,
        minDate: Date,
        maxDate: Date,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isTextInput: Boolean,
    },
    data() {
        return {
            minVal: '',
            maxVal: ''
        }
    },
    setup(props) {
        const model = ref()
        let { initialValue } = toRefs(props)
        model.value = initialValue.value
        return { model }
    },
    methods: {
        handleDate (modelData) {
            this.model.value = modelData
        }
    },
    mounted() {
        this.minVal = this.minDate ? '1900-01-01' : this.minDate
        this.maxVal = this.maxDate ? '2100-12-31' : this.maxDate 
    }
}
</script>